import React, {useEffect, useState} from 'react'
import {useSelector} from "react-redux";
import {Controller, FormProvider, useForm, useFormContext} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
import axios from "axios";
import SubmitButton from "../../../form/submit_button";
import _ from "lodash";
import {serialize} from 'object-to-formdata'

function FormInput({name, type, title, ...rest}) {
  const {control, errors} = useFormContext();
  return (
    <div className="form-group">
      <label htmlFor={name}>{title}</label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <input
          {...field}
          type={type}
          className="form-control"
          style={{width: "100%"}}
          {...rest}
        />}
      />
      <ErrorMessage errors={errors} name={name}
                    render={({message}) => <div className="invalid-feedback d-block">{message}</div>}/>
    </div>
  )
}

function FormFileInput({name, title, methods, ...rest}) {
  return (
    <div className="form-group">
      <label htmlFor={name}>{title}</label>
      <input
        className="form-control"
        style={{width: "100%"}}
        name={name}
        type="file"
        ref={methods.register}
        {...rest}/>

      <ErrorMessage errors={methods.errors} name={name}
                    render={({message}) => <div className="invalid-feedback d-block">{message}</div>}/>
      {/*{methods.errors[name] && <div className="invalid-feedback d-block">{methods.errors[name].join(", ")}</div>}*/}
    </div>
  )
}

const ContactForm = ({methods, onFinished, contact, setSelectedContact, setContacts}) => {
  const contactsUrl = useSelector(state => state.contactsUrl)

  const [sending, setSending] = useState(false)
  const [showThanks, setThanks] = useState(false)

  const sendForm = (data) => {
    console.log(data)
    console.log(serialize(data).get("image"))
    setSending(true)

    axios({
      method: contact ? "put" : "post",
      url: contact ? `${contactsUrl}/${contact.id}` : contactsUrl,
      data: serialize({tag_owner: data})
    }).then(response => {
        console.warn(response.data)
        if (response.data.status == "OK") {
          setSelectedContact(null)
          methods.reset({
            firstname: "",
            lastname: "",
            job_title: "",
            company: "",
            email: "",
            phone: "",
            image: null
          })
          setThanks(true)
          onFinished()
          setTimeout(() => setThanks(false), 3000)
        } else {
          {
            _.map(response.data.errors, (messages, field) => {
              {
                _.map(messages, (message, index) => {
                  console.log("adding error", field, message)
                  methods.setError(field, {type: "not valid", message: message})
                })
              }
            })
          }
        }
      },
      error => {
        alert(error)
        console.error(error)
        setSending(false)
      }).then(function () {
      setSending(false)
    })
  }

  return <>
    {showThanks &&
    <div className="alert alert-success">
      Contact Added
    </div>
    }
    <FormProvider {...methods} >
      <form onSubmit={methods.handleSubmit(sendForm)}>
        <FormInput name="firstname" title="Firstname" type="text"/>
        <FormInput name="lastname" title="Lastname" type="text"/>
        <FormInput name="job_title" title="Jobtitle" type="text"/>
        <FormInput name="company" title="Company *" type="text"/>
        <FormInput name="email" title="E-Mail *" type="text"/>
        <FormInput name="phone" title="Phone (optional)" type="text"/>
        <FormFileInput name="image" title="Image *" methods={methods}/>
        <SubmitButton sending={sending}/>
      </form>
    </FormProvider>
  </>
}


const loadContacts = (url, setIsLoading, setError, setContacts) => {
  setIsLoading(true)
  setError(null)
  setContacts([])

  axios.get(url).then(response => {
      if (response.data.status === "OK") {
        console.table(response.data.contacts)
        setError(null)
        setContacts(response.data.contacts)
      } else {
        setError(response.data.message)
        setContacts([])
      }
    },
    error => {
      alert(error)
      console.error(error)

      setError(response.data.message)
      setContacts([])
    }).then(function () {
    setIsLoading(false)
  })
}

export default function Contacts() {
  const contactsUrl = useSelector(state => state.contactsUrl)
  const contactsChangePositionUrl = useSelector(state => state.contactsChangePositionUrl)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [contacts, setContacts] = useState([])
  const [selectedContact, setSelectedContact] = useState(null)

  useEffect(() => {
    loadContacts(contactsUrl, setIsLoading, setError, setContacts)
  }, [])

  const methods = useForm({
    shouldUnregister: true,
    defaultValues: {
      firstname: selectedContact?.firstname || "",
      lastname: selectedContact?.lastname || "",
      job_title: selectedContact?.job_title || "",
      company: selectedContact?.company || "",
      email: selectedContact?.email || "",
      phone: selectedContact?.phone || "",
    }
  })

  const deleteContact = (id) => {
    setIsLoading(true)
    setError(null)
    setContacts([])

    axios.delete(`${contactsUrl}/${id}`).then(response => {
        if (response.data.status === "OK") {
          console.table(response.data.contacts)
          setError(null)
          setContacts(response.data.contacts)
        } else {
          setError(response.data.message)
          setContacts([])
        }
      },
      error => {
        alert(error)
        console.error(error)

        setError(response.data.message)
        setContacts([])
      }).then(() => setIsLoading(false))
  }

  // aka set contact position
  const moveContact = (id, moveAction) => {
    setIsLoading(true)
    setError(null)
    setContacts([])

    console.log({id, moveAction})

    axios.put(contactsChangePositionUrl.replace("@@contact_id@@", id), {id: id, move_action: moveAction}).then(response => {
        if (response.data.status === "OK") {
          console.table(response.data.contacts)
          setError(null)
          setContacts(response.data.contacts)
        } else {
          setError(response.data.message)
          setContacts([])
        }
      },
      error => {
        alert(error)
        console.error(error)

        setError(response.data.message)
        setContacts([])
      }).then(() => setIsLoading(false))
  }

  if (isLoading) {
    return <div className={"text-center"}>
      <div className="spinner-border text-dark" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  } else if (error) {
    return <div className={"text-center"}>
      An error occurred while loading.

      <hr/>
      {error}
      <hr/>

      <button className="btn btn-danger"
              onClick={() => loadContacts(contactsUrl, setIsLoading, setError, setContacts)}
      >Reload
      </button>
    </div>
  }

  const sortedContacts = _.sortBy(contacts, ["contact_position", "name", "email", "id"], ["asc", "asc", "asc", "asc",])
  const maxContactPosition = _.maxBy(contacts, "contact_position")
  const minContactPosition = _.minBy(contacts, "contact_position")

  return <div>
    <div className="row">
      <div className="col-md-6">
        <div className="shadow m-2 p-2">
          {selectedContact && <>
            You currently have {selectedContact.name} selected.
            <button className="btn btn-danger float-right" onClick={() => {
              setSelectedContact(null)
              methods.reset({
                firstname: "",
                lastname: "",
                job_title: "",
                company: "",
                email: "",
                phone: "",
                image: null
              })
            }}>
              Unselect{" "}
              <i className="fa fa-times" aria-hidden="true"/>
            </button>
            <hr/>
          </>}

          <ContactForm methods={methods}
                       contact={selectedContact}
                       setContacts={setContacts}
                       setSelectedContact={setSelectedContact}
                       onFinished={() => loadContacts(contactsUrl, setIsLoading, setError, setContacts)}/>
        </div>
      </div>
      <div className="col-md-6">
        <div className="shadow m-2 p-2">
          {sortedContacts.length > 0 ? <>
            {sortedContacts.map(contact => {
              return <div key={contact.id} className={"row"}>
                {contact.imageUrl && <div className="col-3">
                  <img className={"img-fluid img-thumbnail"} src={contact.imageUrl}/>
                </div>}
                <div className="col-5">
                  {contact.name}
                  <br/>
                  {contact.email}
                  <br/>
                  {contact.job_title}
                  <br/>
                  <a href={contact.vcfUrl}>Download vcf here</a>
                </div>
                <div className="col-4 text-right">
                  <button className="btn fa-btn" onClick={() => {
                    setSelectedContact(contact)
                    methods.reset({
                      firstname: contact?.firstname || "",
                      lastname: contact?.lastname || "",
                      job_title: contact?.job_title || "",
                      company: contact?.company || "",
                      email: contact?.email || "",
                      phone: contact?.phone || "",
                    })
                  }}>
                    <i className="fa fa-edit"/>
                  </button>
                  <button className="btn fa-btn" onClick={() => deleteContact(contact.id)}>
                    <i className="fa fa-trash"/>
                  </button>
                  {sortedContacts.length > 1 && <>
                    {minContactPosition.contact_position !== contact.contact_position &&
                    <button className="btn fa-btn" onClick={() => moveContact(contact.id, "UP")}>
                      <i className="fa fa-chevron-up"/>
                    </button>}
                    {maxContactPosition.contact_position !== contact.contact_position &&
                    <button className="btn fa-btn" onClick={() => moveContact(contact.id, "DOWN")}>
                      <i className="fa fa-chevron-down"/>
                    </button>}
                    <hr/>
                  </>}
                </div>
                <div className="col-12">
                  <hr/>
                </div>

              </div>
            })}
          </> : <>
            <div className="row">
              <div className="col-12">
                Currently you have no contacts added.
              </div>
            </div>
          </>}
        </div>
      </div>
    </div>
  </div>;
}
